/**
 * Admin V3 — Compliance — Profiles-by-state table (Plan §2.2 M-F-14).
 *
 * G11.E — Rows are now CLICKABLE when `onRowClick` is provided. Clicking
 * a state row navigates to the DriversList filtered by that compliance
 * state (wired by CompliancePilotPage's `handleOpenStateInDriversList`).
 *
 * Backward-compatible: if `onRowClick` is omitted, rows render as pure
 * presentation (unchanged from the pre-G11 behaviour).
 */
import React from 'react';
import { lifecycleStateMeta } from '../../shared/visualTokens';
import { t } from '../../i18n';

const CompliancePilotTable = ({ rows, locale = 'fr', onRowClick }) => {
  const clickable = typeof onRowClick === 'function';
  return (
    <div className="overflow-x-auto" data-testid="compliance-pilot-table">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-slate-600">
            <th className="py-2 pr-4">{t('compliance.dashboard.table.state', locale)}</th>
            <th className="py-2 pr-4 text-right">{t('compliance.dashboard.table.driver', locale)}</th>
            {clickable && (
              <th className="py-2 pr-4 text-right">{t('compliance.documents.table.actions', locale)}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const meta = lifecycleStateMeta[r.state];
            return (
              <tr
                key={r.state}
                className={`border-b border-slate-100 ${clickable ? 'hover:bg-slate-50 cursor-pointer' : ''}`}
                onClick={clickable ? () => onRowClick(r.state) : undefined}
                data-testid={`compliance-state-row-${r.state}`}
              >
                <td className="py-2 pr-4">
                  {meta ? (
                    <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${meta.pill}`}>
                      {t(meta.labelKey, locale)}
                    </span>
                  ) : (
                    <span className="text-slate-600">{r.state}</span>
                  )}
                </td>
                <td className="py-2 pr-4 text-right font-mono text-slate-900">{r.count}</td>
                {clickable && (
                  <td className="py-2 pr-4 text-right">
                    <span
                      className="text-blue-700 hover:underline text-xs"
                      data-testid={`compliance-state-deeplink-${r.state}`}
                    >
                      {t('compliance.dashboard.deeplink.openDrivers', locale)}
                    </span>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CompliancePilotTable;
